export const PERMISSION_NAMES = ['Read', 'Create/Update', 'Delete', 'Admin'];